import { ChangePartner } from './ChangePartner';

export class ChangePartnerLinkUrl extends ChangePartner {
  type: string = 'Partner.ChangeLinkUrl';
}
